/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FeedbackSourceApiModel } from './feedback-source';

export interface CustomerFeedbackSettingsApiModel {
  /**
   * Feedback source active flag
   */
  active?: number;
  /**
   * Allow unauthorized customers attach files to feedback
   */
  allow_attach_file_for_unauthorized_customer?: number;
  /**
   * Allow unauthorized customers leave ratings
   */
  allow_rating_for_unauthorized_customer?: number;
  /**
   * Allow unauthorized customers leave reviews
   */
  allow_review_for_unauthorized_customer?: number;
  /**
   * Allow leave ratings/reviews
   */
  allowed?: CustomerFeedbackSettingsApiModelAllowedEnum;
  /**
   * Text displayed for customers as invitation
   */
  feedback_invitation_text?: string;
  /**
   * Maximum allowable number of ratings/reviews from the customer to one feedback source (0 is unlimited).
   */
  feedback_per_customer_limit?: number;
  feedback_source?: FeedbackSourceApiModel;
}
export enum CustomerFeedbackSettingsApiModelAllowedEnum {
  None = 'none',
  AuthorizedUsersOnly = 'authorized-users-only',
  AllUsers = 'all-users'
}
